import { useState, useEffect } from 'react';
import { useDataFetch } from '../../../hooks/use-data-fetch';
import { Order } from './use-orders';

/**
 * Hook personalizado para obtener los detalles de una orden específica
 * @param orderId ID de la orden a consultar
 * @returns Estado de carga, error, datos de la orden y funciones relacionadas
 */
export const useOrderDetails = (orderId: string | undefined) => {
  const [order, setOrder] = useState<Order | null>(null);
  const { getData } = useDataFetch();
  
  // Consultar los detalles de la orden
  const { 
    data, 
    isLoading, 
    isError, 
    error,
    refetch 
  } = getData(
    ["order", orderId],
    `/order/${orderId}`,
    { enabled: !!orderId } // Solo hacer la consulta si hay un orderId
  );
  
  // Actualizar el estado cuando se reciben los datos
  useEffect(() => {
    if (data?.data?.order) {
      setOrder(data.data.order);
    }
  }, [data]);

  return {
    order,
    isLoading,
    isError,
    error,
    refetch
  };
};
